import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { reduxKey } from './constants';
import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
export const stateUpdated = createAction(`${reduxKey}.STATE_UPDATED`, (updated)=>({
        updated
    }));
// Dynamic redux
export const reduxModuleLoaded = createAction(`${reduxKey}.REDUX_READY`, ()=>({}));
export const muroReady = createAction(`${reduxKey}.MURO_READY`, ()=>({}));
export const showGenericAlert = createAction(`${reduxKey}.SHOW_ALERT`, (config)=>_object_spread({}, config));
export const closeGenericAlert = createAction(`${reduxKey}.CLOSE_ALERT`, ()=>({}));
export const showGenericConfirm = createAction(`${reduxKey}.SHOW_CONFIRM`, (config, promiseResolver)=>({
        config,
        promiseResolver
    }));
export const closeGenericConfirm = createAction(`${reduxKey}.CLOSE_CONFIRM`, ()=>({}));
export const showDeleteImageConfirm = createAction(`${reduxKey}.SHOW_DELETE_IMAGE_CONFIRM`, ({ deviationId })=>({
        deviationId
    }));
export const closeDeleteImageConfirm = createAction(`${reduxKey}.CLOSE_DELETE_IMAGE_CONFIRM`, ()=>({}));
export const showMediaSelector = createAction(`${reduxKey}.SHOW_MM`, ({ mmConfig, promiseResolver })=>({
        mmConfig,
        promiseResolver
    }));
export const initToolBrushDefault = createAction(`${reduxKey}.INIT_TOOL_BRUSH`, ()=>({}));
export const storeActiveBrush = createAction(`${reduxKey}.STORE_BRUSH`, ({ tool, brushName })=>({
        tool,
        brushName
    }));
export const updateStoredBrushes = createAction(`${reduxKey}.UPDATE_BRUSH_STORE`, ({ tool, brushName })=>({
        tool,
        brushName
    }));
export const loadStoredBrush = createAction(`${reduxKey}.LOAD_BRUSH_STORE`, (tool, currentBrush)=>({
        tool,
        currentBrush
    }));
export const backToDraw = createAction(`${reduxKey}.MICRO_BACK_TO_DRAW`, ()=>({}));
export const backToErase = createAction(`${reduxKey}.BACK_TO_ERASE`, ()=>({}));
export const backToSelect = createAction(`${reduxKey}.BACK_TO_SELECT`, ()=>({}));
export const backToTransform = createAction(`${reduxKey}.BACK_TO_TRANSFORM`, ()=>({}));
export const updateTopTab = createAction(`${reduxKey}.UPDATE_TOP_TAB`, ({ topTab })=>({
        topTab
    }));
export const updateTab = createAction(`${reduxKey}.UPDATE_TAB`, ({ tab })=>({
        tab
    }));
export const updateTool = createAction(`${reduxKey}.UPDATE_TOOL`, ({ tool })=>({
        tool
    }));
export const updateAdjust = createAction(`${reduxKey}.UPDATE_ADJUST`, ({ adjust })=>({
        adjust
    }));
export const updateColorPickerColor = createAction(`${reduxKey}.UPDATE_COLOR_PICKER_COLOR`, ({ colorPickerColor })=>({
        colorPickerColor
    }));
export const updateLayerFlyoutOpen = createAction(`${reduxKey}.UPDATE_LAYER_FLYOUT`, ({ layerFlyoutOpen })=>({
        layerFlyoutOpen
    }));
export const updateDeviationId = createAction(`${reduxKey}.UPDATE_DEVIATION_ID`, ({ deviationId })=>({
        deviationId
    }));
export const updateContentVersion = createAction(`${reduxKey}.UPDATE_CONTENT_VERSION`, ({ contentVersion })=>({
        contentVersion
    }));
export const updateFileSaveState = createAction(`${reduxKey}.UPDATE_FILE_SAVE_STATE`, ({ fileSaveState })=>({
        fileSaveState
    }));
export const updateFileLoadState = createAction(`${reduxKey}.UPDATE_FILE_LOAD_STATE`, ({ fileLoadState })=>({
        fileLoadState
    }));
export const createFileSaveRequest = createAction(`${reduxKey}.CREATE_FILE_SAVE_REQUEST `, (payload)=>payload);
export const createDeviationLoadRequest = createAction(`${reduxKey}.CREATE_DEVIATION_LOAD_REQUEST`, (payload)=>payload);
export const createDeviationCreate = createAction(`${reduxKey}.CREATE_DEVIATION_CREATE `, (payload)=>payload);
export const createDeviationImageRequest = createAction(`${reduxKey}.CREATE_DEVIATION_IMAGE_REQUEST `, (payload)=>payload);
export const createDeviationFetchRequest = createAction(`${reduxKey}.CREATE_DEVIATION_FETCH_REQUEST `, (payload)=>payload);
export const createDeviationDeleteRequest = createAction(`${reduxKey}.CREATE_DEVIATION_DELETE_REQUEST `, (payload)=>payload);
export const updateGenerationId = createAction(`${reduxKey}.UPDATE_GENERATION_ID`, ({ generationId })=>({
        generationId
    }));
export const updateDreamupRequestState = createAction(`${reduxKey}.UPDATE_DREAMUP_REQUEST_STATE`, ({ requestState })=>({
        requestState
    }));
export const storeDreamupRestrictions = createAction(`${reduxKey}.STORE_DREAMUP_RESTRICTIONS `, (payload)=>payload);
export const createInpaintRequest = createAction(`${reduxKey}.CREATE_INPAINT_REQUEST `, (payload)=>payload);
export const createSketchGuidedRequest = createAction(`${reduxKey}.CREATE_SKETCH_GUIDED_REQUEST `, (payload)=>payload);
export const createSyncDreamup = createAction(`${reduxKey}.CREATE_SYNC_DREAMUP `, (payload)=>payload);
export const createCanvasRequest = createAction(`${reduxKey}.CREATE_CANVA_REQUEST `, (payload)=>payload);
export const createDreamupResultsRequest = createAction(`${reduxKey}.CREATE_DREAMUP_RESULTS_REQUEST `, (payload)=>payload);
export const updateBrushFlyout = createAction(`${reduxKey}.UPDATE_BRUSH_FLYOUT`, ({ brushFlyoutOpen })=>({
        brushFlyoutOpen
    }));
export const updateEraseFlyout = createAction(`${reduxKey}.UPDATE_ERASE_FLYOUT`, ({ eraseFlyoutOpen })=>({
        eraseFlyoutOpen
    }));
export const updateSelectFlyout = createAction(`${reduxKey}.UPDATE_SELECT_FLYOUT`, ({ selectFlyoutOpen })=>({
        selectFlyoutOpen
    }));
export const updateTransformFlyout = createAction(`${reduxKey}.UPDATE_TRANSFORM_FLYOUT`, ({ transformFlyoutOpen })=>({
        transformFlyoutOpen
    }));
export const updateTextFlyout = createAction(`${reduxKey}.UPDATE_TEXT_FLYOUT`, ({ textFlyoutOpen })=>({
        textFlyoutOpen
    }));
export const updateMiniTool = createAction(`${reduxKey}.UPDATE_MINI_TOOL`, ({ miniTool })=>({
        miniTool
    }));
export const updateMicroTool = createAction(`${reduxKey}.UPDATE_MICRO_TOOL`, ({ microTool })=>({
        microTool
    }));
export const updateMaxCapacity = createAction(`${reduxKey}.UPDATE_MAX_CAPACITY`, ({ maxCapacity })=>({
        maxCapacity
    }));
export const updateFreeCapacity = createAction(`${reduxKey}.UPDATE_FREE_CAPACITY`, ({ freeCapacity })=>({
        freeCapacity
    }));
export const updateStashFolderId = createAction(`${reduxKey}.UPDATE_STASH_FOLDER_ID`, ({ stashFolderId })=>({
        stashFolderId
    }));
export const updateLibraryWasInitialized = createAction(`${reduxKey}.UPDATE_LIBRARY_INITIALIZED`, ({ wasInitialized })=>({
        wasInitialized
    }));
export const initializeMyLibrary = createAction(`${reduxKey}.INITIALIZE_MY_LIBRARY`, (deviations)=>({
        deviations
    }));
export const fetchNextMyLibrary = createCallbackActionCreator(`${reduxKey}.FETCH_NEXT_MY_LIBRARY`);
export const insertDeviationIntoLibrary = createAction(`${reduxKey}.INSERT_DEVIATION_MY_LIBRARY`, ({ deviation })=>({
        deviation
    }));
export const updateUsername = createAction(`${reduxKey}.UPDATE_USERNAME`, ({ username })=>({
        username
    }));
export const updateCoreStatus = createAction(`${reduxKey}.UPDATE_CORE_STATUS`, ({ coreStatus })=>({
        coreStatus
    }));

//# sourceMappingURL=actions.js.map